module.exports = __webpack_public_path__ + "img/banner-past-draws.68674dfc.png";